var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "24px",
    viewBox: "0 0 40 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "menu-hamburger-1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "03.0_Cadastro-do-usuario---menu-aberto",
    transform: "translate(-51.000000, -78.000000)",
    fill: "#2B2B2B",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "menu-hamburger-1",
    transform: "translate(51.000000, 78.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.205338,0.184522728 C12.4513683,0.430553032 12.4513683,0.829446968 12.205338,1.07547727 L2.15,11.129 L39.1861765,11.1298607 C39.5349879,11.1298607 39.8177555,11.4126283 39.8177555,11.7614397 C39.8177555,12.085336 39.5739406,12.3522863 39.259832,12.3887695 L39.1861765,12.3930186 L2.154,12.393 L12.205338,22.4442442 C12.4513683,22.6902745 12.4513683,23.0891684 12.205338,23.3351987 C11.9593077,23.581229 11.5604138,23.581229 11.3143835,23.3351987 L0.184522728,12.205338 C-0.061507576,11.9593077 -0.061507576,11.5604138 0.184522728,11.3143835 L11.3143835,0.184522728 C11.5604138,-0.061507576 11.9593077,-0.061507576 12.205338,0.184522728 Z",
    id: "Combined-Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.806d1a6230a53b6d14dd6da8839cb796.svg";
export { ForwardRef as ReactComponent };